export const getBrandId = (): string | null => {
  return localStorage.getItem('brandId');
};
